import { useCallback, useState } from 'react';
import { useTimeout } from './useTimeout';

export const useMediaLoading = () => {
  const [isMediaLoading, setIsMediaLoading] = useState(false);
  const [isMediaDelayLoading, setIsMediaDelayLoading] = useState(false);
  const timeoutDelay = 300;

  const timeout = useTimeout();

  const onMediaLoadStart = useCallback(() => {
    setIsMediaLoading(true);
    setIsMediaDelayLoading(true);
    timeout.set(() => {
      timeout.clear();
      setIsMediaDelayLoading(false);
    }, timeoutDelay);
  }, [timeout]);

  const onMediaLoaded = useCallback(() => {
    setIsMediaLoading(false);
  }, []);

  return {
    isMediaLoading: isMediaLoading || isMediaDelayLoading,
    onMediaLoadStart,
    onMediaLoaded,
  };
};
